import { render, staticRenderFns } from "./SparsAdministration.vue?vue&type=template&id=7568b5a5&scoped=true"
import script from "./SparsAdministration.vue?vue&type=script&lang=js"
export * from "./SparsAdministration.vue?vue&type=script&lang=js"
import style0 from "./SparsAdministration.vue?vue&type=style&index=0&id=7568b5a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568b5a5",
  null
  
)

export default component.exports